module.exports = __webpack_public_path__ + "46dd3d1f35dfb8e0eaad42623213d4b4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/sprite.png
// module id = 400
// module chunks = 0